import { queryCache } from 'react-query';
import dayjs from 'dayjs';
import { Fusion, FusionBatchOrderCompany } from './fusion-process-types';

export const QUERY_KEY_FUSION = (id: string) => ['fusion', id];

function getFusion(id: string) {
  return queryCache.getQueryData<Fusion>(QUERY_KEY_FUSION(id));
}

export function getBatch(fusionId: string, fusionBatchId: string | null) {
  const fusion = getFusion(fusionId);
  if (!fusion || !fusionBatchId) {
    return null;
  }

  return fusion.batches.find((batch) => batch.id === fusionBatchId) ?? null;
}

export const QUERY_KEY_FUSION_ORDERS = 'fusionOrders';

export function getAvailableBatchOrders() {
  return queryCache.getQueryData<FusionBatchOrderCompany[]>(
    QUERY_KEY_FUSION_ORDERS,
  );
}

export function getBatchOrder(tcNumber: number) {
  const orders = getAvailableBatchOrders();
  return orders?.find((order) => order.tcNumber === tcNumber);
}

export const QUERY_KEY_FUSION_DOCUMENT = (data: {
  documentId: string;
  batchId: string;
  fusionId: string;
}) => ['fusionDocument', data.documentId, data.batchId, data.fusionId];

export function formatDate(date: Date) {
  return dayjs(date).format('YYYY-MM-DD');
}
